// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { pxToEm } from 'theme';
import type { CoverImageProps } from './MBImage.types';

export const CoverImage = styled.div<CoverImageProps>`
  width: 100%;
  display: flex;
  position: relative;
  background-color: ${({ theme }) => theme.palette.grey[200]};
  border-radius: ${({ borderRadius }) => pxToEm(borderRadius)};
  cursor: pointer;
  padding-bottom: ${({ aspectRatio }) => {
    let paddingBottom = '100%';
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!isNaN(aspectRatio as number)) {
      return `${aspectRatio}%`;
    }
    switch (aspectRatio) {
      case 'landscape':
        paddingBottom = '70%';
        break;
      case 'portrait':
        paddingBottom = '130%';
        break;
      case 'wide':
        paddingBottom = '55%';
        break;
      case 'long':
        paddingBottom = '170%';
        break;
      default:
        paddingBottom = '100%';
    }
    return paddingBottom;
  }};
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: 1;
    border-radius: ${({ borderRadius }) => pxToEm(borderRadius)};
    pointer-events: none;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    border-radius: ${({ borderRadius }) => borderRadius}px;
    font-size: 0;
    object-fit: ${({ isImageContained }) =>
      isImageContained ? 'contain' : 'cover'};
    -webkit-filter: brightness(0.95);
    filter: brightness(0.95);
  }
`;
